import { Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  loginInfoDataTableConfig,
  UserLoginHistoryRow,
} from '../../user-management.config';
import { StatusCodes } from 'src/app/shared/utility/constants';
import { UserService } from 'src/app/features/service/user.service';

@Component({
  selector: 'app-login-information',
  templateUrl: './login-information.component.html',
  styleUrl: './login-information.component.scss',
})
export class LoginInformationComponent {
  @Input() userId: any;
  public loginInfoTableData: UserLoginHistoryRow[] = [];
  public readonly loginInfoDataTableConfig = loginInfoDataTableConfig;
  public loginInfoDataSearched = false;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly userService: UserService
  ) {}

  ngOnInit() {
    if (this.userId) {
      this.getUserHistoryByUserId(this.userId);
    }
  }

  private getUserHistoryByUserId(userId: number) {
    this.userService
      .fetchUserLoginHistory(userId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          if (response.statusCode === StatusCodes.Success) {
            this.loginInfoTableData = (response.data ?? []).map(
              (row: Omit<UserLoginHistoryRow, 'id'>, index: number) => ({
                ...row,
                id: index + 1,
              })
            );
            this.loginInfoDataSearched = true;
          }
        },
      });
  }
}
